const self = {};
self.email = /^([^.@]+)(\.[^.@]+)*@([^.@]+\.)+([^.@]+)$/;
export default self;
